import {Modal} from 'bootstrap';
import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {PermissionsService} from '../../../../Services/permissions.service';

@Component({
  selector: 'app-modal-uninvoiced-workorders',
  templateUrl: './modal-uninvoiced-workorders.component.html',
  styleUrls: ['./modal-uninvoiced-workorders.component.css'],
  standalone: false
})
export class ModalUninvoicedWorkordersComponent implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;
  @Input() vm: any;
  constructor(
    public router: Router,
    private permissionsService: PermissionsService
  ) { }

  get hasEditWorkOrderPermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditWorkOrders');
  }

  ngOnInit() {
  }

  generateWorkOrderInvoice(id) {
    // $('#uninvoicedWorkOrders').modal('hide');
    // $state.go('app.admin.transactions.invoice.form', { invoiceId: 'newAR', workorderId: id });
    this.router.navigateByUrl('/transactions/invoice/ar/form?invoiceId=newAR&workorderId=' + id);
  }
  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }

}
